import { render, staticRenderFns } from "./productOptions.vue?vue&type=template&id=56d33242&"
import script from "./productOptions.vue?vue&type=script&lang=js&"
export * from "./productOptions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports